import { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom"
import moment from 'moment';
import {
  Grid, useMediaQuery, makeStyles, Button, TextField, Snackbar
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { devicesActions, sessionActions, layoutActions } from './store';
import { useTranslation } from './LocalizationProvider';
import usePersistedState from './common/usePersistedState';
import { api_call, console_log, empty, get_data_value, get_utc_timestamp_ms, validateEmail } from './helpers/untils';
import { MACHINE_ENVIRONMENT, RECAPTCHA_ENABLED, SHARE_ACCESS_TYPE } from './config/constant';
import { getSettingPersist, setSettingPersist } from './helpers/misc';
import CaptchaBox from './components/CaptchaBox';
import TemporaryUploadPage from './TemporaryUploadPage';
import TemporaryMainBlock from './map/TemporaryMainBlock';
import TemporarySoonPage from './TemporarySoonPage';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    textAlign: 'center',
    color: theme.palette.primary.main,
  },
  chromeLogoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: '#e5e5e5',
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
    marginTop: '1rem',
    marginBottom: '1rem',
    padding: '4px',
  },
  chromeLogoImg: {
    width: 'calc(100% - 210px)',
    height: 'auto'
  },
  chromeLogoTxt: {
    flex: 1,
    paddingLeft: '0.5rem',
    textAlign: 'left',
    fontSize: '20px',
    fontWeight: '700',
    color: '#333333',
  },
  form: {
    maxWidth: theme.spacing(52),
    padding: theme.spacing(5),
    width: '100%',
    position: 'relative',
    margin: 'auto'
  },
  formWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh'
  },
  loadingView: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#abd3df'
  }
}));

const TripAccessPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation()
  const theme = useTheme();
  const t = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const params = new URLSearchParams(location.search)
  const mode = params.get("mode")
  const isTest = mode === 'test' ? true : false

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const pageActiveRef = useRef(false)
  useEffect(() => {
    pageActiveRef.current = true
    return () => {
      pageActiveRef.current = false
    }
  }, [])

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [authenticated, setAuthenticated] = useState(false);

  const [verified, setVerified] = useState(false)
  const refVerifyField = useRef(false)
  const authenticateRef = useRef(false)
  const [pageData, setPageData] = useState({});
  const [currentLink, setCurrentLink] = useState(null);
  const [currentTuroTrip, setCurrentTuroTrip] = useState(null);
  const pageDataRef = useRef({})

  ///////////////////////////////////////////////// authenticate form ///////////////////////////////////////////////////////////
  const [reservationId, setReservationId] = usePersistedState('tripReservationId', (MACHINE_ENVIRONMENT === "dev" ? "47326185" : ""));
  const [phone, setPhone] = usePersistedState('tripPhone', (MACHINE_ENVIRONMENT === "dev" ? "6958426" : ""));
  const [email, setEmail] = useState("")  // usePersistedState('loginEmail', (MACHINE_ENVIRONMENT === 'dev' ? 'quanseng632@gmail.com' : ''));
  const [failed, setFailed] = useState(false);
  const [errorFields, setErrorFields] = useState([]);

  ///////////// start recaptcha part //////////////////////////////////////////////////////////////////////////
  const captchaKey = 'captcha_trip_access'
  const [recaptcha, setRecaptcha] = useState(RECAPTCHA_ENABLED === "false" ? "xxxxxxxxxxxxxxxxx" : "");
  const [captchaTimestamp, setCaptchaTimestamp] = useState(get_utc_timestamp_ms());
  const updateCaptchaSettingEnabled = (value) => {
    const oldValue = getSettingPersist(captchaKey)
    if (oldValue !== value) {
      setSettingPersist(captchaKey, value)
      setCaptchaTimestamp(get_utc_timestamp_ms())
    }
  }
  ///////////// end recaptcha part //////////////////////////////////////////////////////////////////////////

  const [pageLoaded, setPageLoaded] = useState(false);

  const handleSpecialKey = (e) => {
    if (e.keyCode === 13 && reservationId && phone && recaptcha) {
      handleSubmit(e);
    }
  }

  const handleSubmit = async (event, payload = null) => {
    console.log(`event, payload::::`, event, payload)
    if (event) {
      event.preventDefault();
      if (!empty(email) && !validateEmail(email)) {
        alert(`Invalid email address`);
        return false
      }
    }
    if (!payload) {
      payload = {
        reservationId: reservationId.trim(),
        phone: phone.trim(),
        email: email.trim(),
        session: ""
      }
    }
    const rand = () => Math.floor((1 + Math.random()) * 0x100000000).toString(16).substring(1);
    const session = payload.session || `${rand()}_${payload.reservationId}_${payload.phone}`;
    payload.session = session;
    const response = await api_call('/api/trip-access-auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    if (response.ok) {
      window.localStorage.setItem('trip_session', session);

      const data = await response.json();
      const device = data?.device
      dispatch(devicesActions.refresh([device]));
      dispatch(devicesActions.select({ id: device.id }));
      dispatch(sessionActions.updateUser({ id: 0, attributes: {}, shareUrl: data?.tripAccessLinkRow?.shareUrl }));
      authenticateRef.current = true
      pageDataRef.current = data
      setPageData(data)
      setCurrentLink(data?.tripAccessLinkRow)
      setCurrentTuroTrip(data?.turoTripInfo)
      setErrorFields([]);
      await loadLinkInfo(false)
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////
      setAuthenticated(true)
      return true;
    } else {
      const errorObj = response;
      const errorMessage = errorObj?.message || errorObj?.error || "Failed to authenticate. Please check your reservation ID and phone number.";
      if (window.localStorage.getItem('trip_session')) {
        window.localStorage.removeItem('trip_session')
      } else {
        if (errorMessage) {
          setToastMessage(errorMessage);
          setSnackbarOpen(true);
        }
        setErrorFields(errorObj?.errorFields || []);
      }
      return false;
    }
  }

  const loadPageFromSession = async () => {
    const session = window.localStorage.getItem('trip_session');
    console_log(`session::::`, session)
    if (session) {
      const payload = {
        reservationId: reservationId.trim(),
        phone: phone.trim(),
        email: email.trim(),
        session: session
      }
      await handleSubmit(null, payload);
    }
    setPageLoaded(true);
  }

  useEffect(() => {
    loadPageFromSession()
  }, [])

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  const device = pageData?.device
  const turoTripInfo = pageData?.turoTripInfo

  const refCurLink = useRef({})
  const [currentDeviceId, setCurrentDeviceId] = useState(null)
  const [current, setCurrent] = useState(moment.utc())
  const [currentTimestamp, setCurrentTimestamp] = useState(moment().unix())
  const startCounter = () => {
    setTimeout(function () {
      setCurrent(moment.utc())
      setCurrentTimestamp(moment().unix())
      startCounter()
    }, 10000)
  }
  const [currentCommands, setCurrentCommands] = useState({})
  const loadLinkInfo = async (is_loop = false) => {
    if (!pageActiveRef.current) {
      return false
    }
    const linkId = pageDataRef.current?.tripAccessLinkRow?.id
    if (linkId) {
      const deviceId = pageDataRef.current?.device?.id || currentDeviceId;
      const reservation_id = pageDataRef.current?.turoTripInfo?.reservation_id || reservationId;

      const response = await api_call(`/api/turo-trip-access-link-info?deviceId=${deviceId}&reservation_id=${reservation_id}&linkId=${linkId}`);
      if (response.ok) {
        const apiData = await response.json();
        const turoTrip = apiData?.turoTrip;
        setCurrentTuroTrip(turoTrip)

        const link = apiData?.link;
        if (link && link.share_settings) {
          let share_settings_obj = JSON.parse(link.share_settings)
          let share_minutes_before = share_settings_obj.share_minutes_before
          let share_minutes_after = share_settings_obj.share_minutes_after
          let avail_upload_minutes_before = share_settings_obj.avail_upload_minutes_before
          if (empty(share_minutes_before)) {
            share_minutes_before = 0
          } else {
            share_minutes_before = parseInt(share_minutes_before)
          }
          if (empty(share_minutes_after)) {
            share_minutes_after = 0
          } else {
            share_minutes_after = parseInt(share_minutes_after)
          }
          if (empty(avail_upload_minutes_before)) {
            avail_upload_minutes_before = 0
          } else {
            avail_upload_minutes_before = parseInt(avail_upload_minutes_before)
          }
          link.share_minutes_before = share_minutes_before
          link.share_minutes_after = share_minutes_after
          link.avail_upload_minutes_before = avail_upload_minutes_before
        }
        //console.log("link:::::::::::::", link)

        if (refVerifyField.current) {
          const oldUnkillApproveStatus = getApproveStatus("unkill")
          const newUnkillApproveStatus = getApproveStatus("unkill", link)
          //console.log("oldUnkillApproveStatus, newUnkillApproveStatus:::::", oldUnkillApproveStatus, newUnkillApproveStatus)
          if (oldUnkillApproveStatus !== "approved" && newUnkillApproveStatus === "approved") {
            setToastMessage("Approved!")
            setSnackbarOpen(true)
          }
        }

        setCurrentLink(link)
        refCurLink.current = link
        if (link.captchaRequired) {
          updateCaptchaSettingEnabled(true)
        } else {
          updateCaptchaSettingEnabled(false)
          if (link.email && link.share_setting_enabled) {
            setVerified(true)
            refVerifyField.current = true
          }
        }
        dispatch(layoutActions.setCurrentSharedLink(link));

        setCurrentDeviceId(link.deviceId)

        const commands = apiData?.commands;
        if (commands) {
          setCurrentCommands(commands)
        }

        if (is_loop) {
          setTimeout(() => {
            loadLinkInfo(is_loop)
          }, 3000) ///////////////
        }
      } else {
        if (response.error) {
          setToastMessage(response.error)
          setSnackbarOpen(true)
        }
      }
    } else {

    }
  }

  useEffect(() => {
    if (authenticated) {
      loadLinkInfo(true)
      startCounter()
    }
  }, [authenticated, pageDataRef.current?.tripAccessLinkRow?.id]);

  const getApproveStatus = (type = "avail", current_link = null) => {
    if (empty(current_link)) {
      current_link = refCurLink.current
    }
    let approve_status = "denied"
    if (current_link) {
      if (current_link.share_settings && current_link.share_setting_enabled) {
        const share_settings_obj = JSON.parse(current_link.share_settings)
        if (share_settings_obj[type + '_car']) {
          if (share_settings_obj[type] && share_settings_obj[type].length > 0) {
            const photo_uploads = current_link.photo_uploads
            let photo_uploads_obj = {}
            if (photo_uploads) {
              photo_uploads_obj = JSON.parse(photo_uploads)
            }
            let approve_key = type + "_approved"
            approve_status = get_data_value(photo_uploads_obj, approve_key, "denied")
          } else {
            approve_status = "approved"
          }
        } else {
          approve_status = "approved"
        }
      } else {
        approve_status = "approved"
      }
    } else {
      approve_status = "denied"
    }
    return approve_status
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={4500}
        message={toastMessage}
      />

      <>
        {
          (pageLoaded) ? (
            <>
              {
                (authenticated) ? (
                  <>
                    {
                      (!empty(currentLink)) ? (
                        <>
                          {
                            (getApproveStatus() === "approved") ? (
                              <>
                                {
                                  (moment(currentLink.from).subtract(currentLink.share_minutes_before, 'minutes') < current && current < moment(currentLink.to).add(currentLink.share_minutes_after, 'minutes')) ? (
                                    <>
                                      <TemporaryMainBlock
                                        currentLink={currentLink}
                                        loadLinkInfo={loadLinkInfo}
                                        commands={currentCommands}
                                        isTest={isTest}
                                      />
                                    </>
                                  ) : (moment(currentLink.to).add(currentLink.share_minutes_after, 'minutes') <= current) ? (
                                    <>
                                      {/* old (expired link page) */}
                                      <TemporarySoonPage
                                        pageType="old"
                                        link={currentLink}
                                        current_timestamp={currentTimestamp}
                                        shareAccessType={SHARE_ACCESS_TYPE.RESERVATION_ID}
                                        approveStatus="approved"
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <TemporarySoonPage
                                        pageType="feature"
                                        link={currentLink}
                                        current_timestamp={currentTimestamp}
                                        shareAccessType={SHARE_ACCESS_TYPE.RESERVATION_ID}
                                        approveStatus="approved"
                                      />
                                    </>
                                  )
                                }
                              </>
                            ) : (
                              <>
                                {
                                  (moment(currentLink.from).subtract(currentLink.avail_upload_minutes_before, 'minutes') < current && current < moment(currentLink.to)) ? (
                                    <>
                                      <TemporaryUploadPage
                                        link={currentLink}
                                        setLink={setCurrentLink}
                                        current_timestamp={currentTimestamp}
                                        type="avail"
                                        approve_status={getApproveStatus()}
                                        loadLinkInfo={loadLinkInfo}
                                        turoTrip={currentTuroTrip}
                                        isTest={isTest}
                                      />
                                    </>
                                  ) : (moment(currentLink.to) <= current) ? (
                                    <>
                                      {/* old (expired link page) */}
                                      <TemporarySoonPage
                                        pageType="old"
                                        link={currentLink}
                                        current_timestamp={currentTimestamp}
                                        shareAccessType={SHARE_ACCESS_TYPE.RESERVATION_ID}
                                        approveStatus="pending"
                                      />
                                    </>
                                  ) : (
                                    <>
                                      {/* feature link page */}
                                      <TemporarySoonPage
                                        pageType="feature"
                                        link={currentLink}
                                        current_timestamp={currentTimestamp}
                                        shareAccessType={SHARE_ACCESS_TYPE.RESERVATION_ID}
                                        approveStatus="pending"
                                      />
                                    </>
                                  )
                                }
                              </>
                            )
                          }
                        </>
                      ) : (
                        <></>
                      )
                    }
                  </>
                ) : (
                  <>
                    <main className={classes.formWrapper}>
                      <div className={classes.form}>
                        <Grid container direction="column" spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              error={errorFields.includes('reservationId')}
                              label={`Reservation #`}
                              name="reservation_id"
                              value={reservationId}
                              autoFocus={!reservationId}
                              onChange={(e) => setReservationId(e.target.value.substring(0, 9))}
                              onKeyUp={handleSpecialKey}
                              //helperText={failed && 'Invalid reservation id or phone'}
                              variant="filled"
                              type="number"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              error={errorFields.includes('phone')}
                              label={`Guest Phone or Host Code`}
                              name="phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value.substring(0, 15))}
                              onKeyUp={handleSpecialKey}
                              //helperText={failed && 'Invalid reservation id or phone'}
                              variant="filled"
                              type="tel"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              // error={failed}
                              label={`Email (Optional)`}
                              name="email"
                              value={email}
                              autoComplete="email"
                              onChange={(e) => setEmail(e.target.value)}
                              onKeyUp={handleSpecialKey}
                              // helperText={failed && 'Invalid email'}
                              variant="filled"
                              type="email"
                            />
                          </Grid>
                          {
                            (RECAPTCHA_ENABLED === "true") && (
                              <Grid item>
                                <CaptchaBox
                                  recaptcha={recaptcha}
                                  setRecaptcha={setRecaptcha}
                                  captchaKey={captchaKey}
                                  captchaTimestamp={captchaTimestamp}
                                  defaultEnabled={true}
                                />
                              </Grid>
                            )
                          }

                          <Grid item>
                            <Button
                              onClick={handleSubmit}
                              onKeyUp={handleSpecialKey}
                              variant="contained"
                              color="secondary"
                              disabled={!reservationId || !phone || !recaptcha}
                              fullWidth
                            >
                              Go
                            </Button>
                          </Grid>
                        </Grid>
                      </div>
                    </main>
                  </>
                )
              }
            </>
          ) : (
            <div className={classes.loadingView}>

            </div>
          )
        }
      </>


    </>
  )
}

export default TripAccessPage;
